import { ComponentProps, useId } from 'react'

import { cn } from '@/lib/utils'

export const Textarea = ({
  label = '',
  className = '',
  maxLength,
  value = '',
  required,
  error = '',
  ...props
}: {
  label?: string
  className?: string
  maxLength?: number
  required?: boolean
  error?: string
  value?: string
} & ComponentProps<'textarea'>) => {
  const id = useId()

  return (
    <div className={cn('w-full', className)}>
      {label && (
        <label htmlFor={id}>
          {label}
          {required && '*'}
        </label>
      )}
      <textarea
        id={id}
        className={cn(
          'block w-full appearance-none rounded-md border border-black bg-white p-3 placeholder:text-neutral-500',
          {
            'border-red-700': error,
          },
        )}
        maxLength={maxLength}
        autoComplete="off"
        spellCheck="false"
        value={value}
        {...props}
      />
      {maxLength && (
        <div className="text-sm">
          {maxLength - value.length} av {maxLength} tegn igjen
        </div>
      )}
      {error && <div className="text-sm text-red-700">{error}</div>}
    </div>
  )
}
